import React, { useState, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useNavigate, useParams } from 'react-router-dom';
import { auth, db } from 'config/firebase';
import {
  where,
  query,
  collection,
  getDocs,
  orderBy,
} from 'firebase/firestore';
import {
  Spinner,
  Card,
  Image,
  Table,
  Row,
  Col,
  Button} from 'react-bootstrap';
import AdvanceTableWrapper from 'components/merlin/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/merlin/advance-table/AdvanceTable';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import PageHeader from 'components/common/PageHeader';
import SoftBadge from 'components/common/SoftBadge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import fedexHomeDeliveryImg from 'assets/merlin/fedex_home_delivery.png';
import priorityMailImg from 'assets/merlin/priority_mail.png';
import upsImg from 'assets/merlin/ups.png';
import uspsImg from 'assets/merlin/usps.png';
import dhlLogo from 'assets/merlin/dhl.png';

const Batches = () => {
  const params = useParams();
  const [batchName, setBatchName] = useState(params.batch);
  console.log(batchName);
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();
  const [currentOrders, setCurrentOrders] = useState('');
  const [firebaseLoading, setFirebaseLoading] = useState(true);
  const [orderCursor, setOrderCursor] = useState();
  const [firstPaint, setFirstPaint] = useState(true);

  const columns = [
    {
      accessor: 'orderId',
      Header: 'Order Id',
      Cell: rowData => {
        const { orderId, orderNumber } = rowData.row.original;
        
        return (
          <span>
            <a href={`/orders/${orderId}`}>{orderNumber}</a>
          </span>
        );
      }
    },
    {
      accessor: 'serviceCode',
      Header: 'Carrier',
      Cell: rowData => {
        const { serviceCode } = rowData.row.original;
        let DisplayText = '';
        switch (serviceCode) {
          case 'fedex_home_delivery':
            DisplayText = <SoftBadge pill bg="light" className="fs--2">
                            <img width={60} src={fedexHomeDeliveryImg} alt="FedEx Home Delivery"></img>
                          </SoftBadge>;
            break;
          case 'usps_priority_mail':
            DisplayText = <SoftBadge pill bg="light" className="fs--2">
                            <img width={60} src={uspsImg} alt="USPS First Class Mail"></img>{" "}
                            <img width={60} src={priorityMailImg} alt="USPS Priority Mail"></img>
                          </SoftBadge>;
            break;
          case 'ups_ground':
            DisplayText = <SoftBadge pill bg="light" className="fs--2">
                            <img width={20} src={upsImg} alt="UPS Ground"></img>{" "}
                            <span style={{color: 'Brown'}}>Ground</span>
                          </SoftBadge>;
            break;
          case 'usps_first_class_mail':
            DisplayText = <SoftBadge pill bg="light" className="fs--2">
                          <img width={60} src={uspsImg} alt="USPS First Class Mail"></img>{" "}
                          <span style={{color: 'Blue'}}> First Class</span>
                        </SoftBadge>;
            break;
          case 'smartmail_parcels_expedited':
            DisplayText = <SoftBadge pill bg="light" className="fs--2">
                          <img width={60} src={dhlLogo} alt="DHL Smartmail Parcels Expedited"></img>{" "}
                          <span style={{color: 'Red'}}> Smartmail</span>
                        </SoftBadge>;
            break;
          default: 
            DisplayText = <SoftBadge pill bg="light" className="fs--2">
                           {serviceCode}
                          </SoftBadge>;
          break;
        }
        
        return (
          <span>
            {DisplayText}
          </span>
        );
      }
    },
    {
      accessor: 'trackingNumber',
      Header: 'Tracking #',
      Cell: rowData => {
        const { trackingNumber } = rowData.row.original;
        
        return (
          <span>
            <a href={`https://www.google.com/search?q=${trackingNumber}`}>{trackingNumber}</a>
          </span>
        );
      }
    },
    {
      accessor: 'shipmentCost',
      Header: 'Shipment Cost',
      Cell: rowData => {
        const { shipmentCost } = rowData.row.original;
        
        return (
          <span>
            ${shipmentCost}
          </span>
        );
      }
    }
  ];

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate('/');
    
    const fetchBatchDetails = async (decodedBatchName) => {
      try {

        let batchReference;
        batchReference  = query(
            collection(db, 'fulfillments'),
            where("batchNumber", "==", decodedBatchName),
            orderBy('createDate', 'desc')
            // startAfter(cursor)
            // limit(500)
          );
        const documentSnapshots = await getDocs(batchReference);
        const ordersArray = [];
        documentSnapshots.forEach(doc => {
          const data = doc.data();
          ordersArray.push({...data});
          console.log(data);
        });
        const lastVisible =
          documentSnapshots.docs[documentSnapshots.docs.length - 1];
        setOrderCursor(lastVisible);
        setCurrentOrders(ordersArray);
        setFirebaseLoading(false);
      } catch (error) {
        console.log(error);
      }
    };

    if (firstPaint) {
      setFirstPaint(false);
      fetchBatchDetails(batchName);
    } else {
      fetchBatchDetails(batchName);
    }
  
  }, [user, loading, navigate]);

  return !firebaseLoading && (
    <>
    <PageHeader

    title={batchName} titleTag="h5" className="mb-3">

    
    <div className='mt-4'>

     
    </div>
    </PageHeader>
    
    
        {!firebaseLoading ? (
          <Card className="">
          <AdvanceTableWrapper
            columns={columns}
            data={currentOrders}
            sortable
            pagination
            setPageSize
            >
            <div className="m-3">
            <Row className="flex-end-center mb-3">
              <Col>
                  <AdvanceTableSearchBox table/>
              </Col>
            </Row>
              <AdvanceTableFooter
                rowCount={currentOrders.length}
                table
                rowInfo
                navButtons
                rowsPerPageSelection
              />
            
            </div>
            
            <AdvanceTable
              table
              headerClassName="bg-200 text-900 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
              tableProps={{
                bordered: false,
                striped: true,
                className: 'fs--1 mb-0 overflow-hidden'
              }}
            />
            <div className="m-3"><AdvanceTablePagination table /></div>
            
          </AdvanceTableWrapper>
          </Card>
        ) : 
          <Row className="align-items-center">

            <Col>
              <Spinner animation="border" variant="primary">
                <span className='visually-hidden'>Loading...</span>
              </Spinner>
            </Col>
          
          </Row>
          }
      
    
    </>
  );
};

export default Batches;
